class _GlobalEvent extends Phaser.Events.EventEmitter {

}
export const GlobalEvent = new _GlobalEvent();
